import React, { useState } from "react";
import { BookOpenText, X, Menu } from "lucide-react";
import { Link, useStaticQuery, graphql } from "gatsby";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const navigation = [
    { name: "News", href: "/news" },
    { name: "Blog", href: "/blog" },
    { name: "Glossary", href: "/glossary" },
    {
      name: "Prompting Guide",
      href: "/blog/ai-user's-guide/mastering-prompt-engineering-with-openai-api-strategies-and-techniques-2024-05-15/",
      className: "header-gradient",
    },
  ];

  return (
    <header className="w-full h-20 z-30 border-b-[3px] border-grey-900 flex justify-between relative items-stretch md:divide-x-[3px] divide-grey-900">
      <Link
        className="flex flex-shrink-0 items-center justify-center h-full p-5 font-bold text-lg md:text-xl bg-grey-900 text-white"
        to="/"
      >
        <BookOpenText className="mr-2" /> {data.site.siteMetadata.title}
      </Link>
      <button
        className="p-5 h-full w-20 border-l-[3px] flex md:hidden border-grey-900 items-center justify-center"
        aria-label="Toggle menu"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
          <Menu className="w-8 h-8" />
      </button>
      <div
        className={`md:flex-row flex-col md:relative fixed top-0 left-0 w-full md:w-auto h-full justify-between md:flex bg-white ${
          isMenuOpen ? "flex" : "hidden"
        }`}
      >
        <div className="flex md:hidden justify-between items-center w-full border-b-[3px] border-grey-900">
          <Link
            className="flex flex-shrink-0 items-center justify-center h-full p-5 font-bold text-lg md:text-xl bg-grey-900 text-white"
            to="/"
          >
            <BookOpenText className="mr-2" /> {data.site.siteMetadata.title}
          </Link>
          <button
            className="p-5 h-full w-20 border-l-[3px] flex md:hidden border-grey-900 items-center justify-center"
            aria-label="Close menu"
            onClick={() => setIsMenuOpen(false)}
          >
            <X className="w-8 h-8" />
          </button>
        </div>
        <nav className="md:space-x-8 font-medium md:px-8 h-full flex md:flex-row flex-col z-50 items-center">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={
                "hover:underline md:border-b-0 text-center py-6 border-b-[3px] border-grey-900 md:w-auto w-full " +
                (item.className || "")
              }
            >
              {item.name}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
